<template>
  <b-row>
    <b-col cols="12">
      <div class="d-flex justify-content-between align-items-start">
        <div>
          <div class="d-flex align-items-center">
            <span class="state-badge text-capitalize mr-2">{{
              racingName
            }}</span>
            <h4 class="mb-0 font-weight-bolder text-capitalize">
              Racing {{ racingName }} Reports
            </h4>
          </div>
          <div class="text-muted">
            All reports for Racing NSW regulatory compliance
          </div>
        </div>

        <b-button variant="primary">
          <feather-icon icon="SendIcon" />
          Submit All Due
        </b-button>
      </div>

      <div class="mt-2">
        <b-row>
          <b-col cols="12" md="3" class="bg-white shadow-lg p-0">
            <div class="border-bottom">
              <div class="p-2 font-weight-bolder">Month/Year</div>
            </div>
            <div
              v-for="(month, i) in months"
              :key="i"
              class="month-item"
              :class="{ 'month-item-active': monthActive.id === month.id }"
              @click="handleChangeMonth(month)"
            >
              <div class="font-weight-bolder">
                {{ month.label }}
              </div>
              <div class="text-muted">
                {{ monthActive.id === month.id ? "Current" : "Submit" }}
              </div>
            </div>
          </b-col>

          <b-col cols="12" md="9" class="bg-white p-0 shadow-lg">
            <div
              class="d-flex justify-content-between align-items-center p-2 border-bottom"
            >
              <strong class="text-capitalize"
                >{{ monthActive.label }} - Racing
                {{ racingName }} Submissions</strong
              >

              <b-badge variant="warning" pill> 1 pending </b-badge>
            </div>

            <div
              v-for="(file, index) in files"
              :key="index"
              class="file-row p-2"
            >
              <div class="d-flex justify-content-between align-items-center">
                <!-- LEFT -->
                <div class="d-flex align-items-center">
                  <div class="file-icon mr-1">
                    <feather-icon icon="FileTextIcon" size="18" />
                  </div>

                  <div>
                    <div class="font-weight-semibold">
                      {{ file.name }}
                    </div>

                    <div class="small text-muted">
                      {{ file.meta }}
                      <span
                        :class="file.statusClass"
                        class="ml-1 font-weight-semibold"
                      >
                        {{ file.status }}
                      </span>
                    </div>
                  </div>
                </div>

                <!-- ACTIONS -->
                <div class="d-flex align-items-center">
                  <b-button size="sm" variant="outline-secondary" class="mr-1">
                    <feather-icon icon="EyeIcon" size="14" />
                  </b-button>

                  <b-button size="sm" variant="outline-primary" class="mr-1">
                    <feather-icon icon="DownloadIcon" size="14" />
                  </b-button>

                  <b-button
                    v-if="file.upload"
                    size="sm"
                    variant="outline-secondary"
                    class="mr-1"
                  >
                    <feather-icon icon="UploadIcon" size="14" />
                  </b-button>

                  <b-button
                    v-if="file.approve"
                    size="sm"
                    :variant="file.approveVariant"
                    class="mr-1"
                  >
                    <feather-icon icon="CheckIcon" size="14" />
                  </b-button>

                  <b-button size="sm" :variant="file.submitVariant">
                    <feather-icon icon="SendIcon" size="14" />
                  </b-button>
                </div>
              </div>
            </div>

            <!-- FOOTER -->
            <div class="d-flex justify-content-end p-1 border-top bg-light">
              <b-button size="sm" variant="outline-secondary" class="mr-1">
                <feather-icon icon="PlusIcon" />
                Generate Report
              </b-button>

              <b-button size="sm" variant="outline-primary" class="mr-1">
                <feather-icon icon="DownloadIcon" />
                Download All
              </b-button>

              <b-button size="sm" variant="primary">
                <feather-icon icon="SendIcon" />
                Submit Pending
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol, BCard, BButton, BBadge } from "bootstrap-vue";
export default {
  components: { BRow, BCol, BCard, BButton, BBadge },
  data() {
    const months = [
      { id: 1, label: "January 2026" },
      { id: 2, label: "December 2025" },
      { id: 3, label: "November 2025" },
      { id: 4, label: "October 2025" },
    ];
    return {
      monthActive: months[0],
      racingName: "",
      months,
      files: [
        {
          name: "racing_nsw_daily_2026-01-09.pdf",
          meta: "Today 06:00 AM •",
          status: "Submitted",
          statusClass: "text-success",
          submitVariant: "success",
        },
        {
          name: "racing_nsw_daily_2026-01-08.pdf",
          meta: "Yesterday •",
          status: "Submitted",
          statusClass: "text-success",
          submitVariant: "success",
        },
        {
          name: "racing_nsw_weekly_w1_2026.pdf",
          meta: "Week 1 •",
          status: "Submitted",
          statusClass: "text-success",
          submitVariant: "success",
        },
        {
          name: "racing_nsw_monthly_january_2026.xlsx",
          meta: "Due: Jan 7 •",
          status: "Pending Approval",
          statusClass: "text-warning",
          upload: true,
          approve: true,
          approveVariant: "warning",
          submitVariant: "secondary",
        },
      ],
    };
  },
  watch: {
    "$route.query.name"(name) {
      this.racingName = name || "NWS";
    },
  },
  mounted() {
    this.racingName = this.$route.query.name || "NWS";
  },
  methods: {
    handleChangeMonth(month) {
      if (!month) return;
      const isActive = month.id === this.monthActive.id;
      if (isActive) return;
      const monthDetail = this.months.find((m) => m.id === month.id);
      if (monthDetail) this.monthActive = monthDetail;
    },
  },
};
</script>

<style lang="scss" scoped>
.state-badge {
  background: #dbeafe;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
}

.month-item {
  padding: 16px 20px;
  border-top: 1px solid #eee;
  border-left: 3px solid transparent;
  cursor: pointer;
  &-active {
    background: #eef2ff;
    border-left-color: #3b82f6;
  }
}

.file-row {
  border-bottom: 1px solid #eee;
}

.file-row:last-child {
  border-bottom: none;
}

.file-icon {
  width: 40px;
  height: 40px;
  background: #eef2ff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
